import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {COACH_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_CLOSE_TO_SC} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import reportPayload from './reportPayload';
import {SeniorCoachCloseToRankContent} from './SeniorCoachCloseToRankContent';

export const SeniorCoachCloseToRankReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      // @ts-expect-error TS(2322): Type '{ title: any; description: any; contentProps... Remove this comment to see the full error message
      title={tt('title', 'Close to Senior Coach')}
      description={tt(
        'description',
        'These Coaches are almost to Senior Coach! Help them get there!',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={SeniorCoachCloseToRankContent}
    />
  );
};

export default withHOC(
  withTranslation('report.seniorCoachCloseToRankReport'),
  withRecordPopover({
    reportPayload,
    popoverName: COACH_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_CLOSE_TO_SC,
    popoverContentProps: {},
  }),
)(SeniorCoachCloseToRankReport);
